import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IPortalAuth } from "src/app/model/IPortal";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class PortalService {
    constructor(private http: HttpClient) {}

    isAuthKeyValid(seoName: string, data: IPortalAuth) {
        return this.http.get(
            `${environment.apiURL}/portal/auth/?seoName=${seoName}&authKey=${
                data.authKey ? data.authKey : ""
            }`
        );
    }

    getPortalDetails(seoName: string) {
        return this.http.get(
            `${environment.apiURL}/portal/details/?seoName=${seoName}`
        );
    }
}
